<template>
  <div class="lodging-add-box">
    <div class="main-container">
      <h2 class="">新規宿泊登録</h2>
      <div class="list-box">
        <div class="list-header-box">
          <div class="">
            <p class="">部屋名</p>
            <p class="">代表者名</p>
            <p class="">人数 / 実人数</p>
            <p class="">チェックイン日</p>
            <p class="">チェックアウト日</p>
            <p class="mail">代表者 email</p>
            <p class="">言語</p>
          </div>
        </div>

        <div class="list-contents-box">
          <div class="">
            <p class="">
              <!-- <select class="" name="" v-model="lodg_data.listing"> -->
              <select class="" name="" v-model="lodg_data.listing_id">
                <option v-for="(list, index) in lists" :key="index" :value="list.id">{{list.name}}</option>
              </select>
            </p>
            <p class=""><input class="" type="text" v-model.number="lodg_data.name"></p>
            <p class="">
              <select class="" name="" v-model="lodg_data.customer_num" @change="set_customer_num">
                <option v-for="num in 16" :key="num" :value="num">{{num}}</option>
              </select>
              <span class="separator">/</span>
              <select class="" name="" v-model="lodg_data.disp_customer_num">
                <option v-for="num in 16" :key="num" :value="num">{{num}}</option>
              </select>
            </p>
            <p class="">
              <vuejs-datepicker
                :format="format"
                :language="languages['ja']"
                v-model="lodg_data.check_in"
                @input="check_in_select"
              >
              </vuejs-datepicker>
            </p>
            <p class="">
              <vuejs-datepicker
                :format="format"
                :language="languages['ja']"
                :disabledDates="disabled_date"
                v-model="lodg_data.check_out"
              >
              </vuejs-datepicker>
            </p>
            <p class="mail"><input class="" type="email" v-model="lodg_data.email"><span>任意：設定しない場合、「新規宿泊登録時」、「名簿未登録のため催促時」のメールは送信されません</span></p>
            <p class="">
              <select class="" name="" v-model="lodg_data.language">
                <option v-for="(lang, index) in select_lang" :key="index" :value="lang.type">{{lang.text}}</option>
              </select>
            </p>
          </div>
        </div>
      </div>

      <input type="button" class="new-add" @click="new_add" v-if="mode == 'add'" value="登録" />
      <div class="flex" v-else >
        <input type="button" class="new-add new-add-s" @click="back_info" value="戻る" />
        <input type="button" class="new-add new-add-s" @click="new_add" value="登録" />
      </div>

    </div>
  </div>
</template>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/src/locale";

export default {
  name: 'LodgingAdd',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    vuejsDatepicker,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      lodg_data: {language: 'en', customer_num: 1, disp_customer_num: 1, email: null },
      format: 'yyyy/MM/dd',
      languages: lang,
      select_lang: [{text: '英語', type: 'en'}, {text: '日本語', type: 'ja'}],
      disabled_date: {
        customPredictor: this.date_chk,
      },
      mode: 'add',
      lodg_id: 0,
      back: '',
      lists: [],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    if (this.$store.getters['loginInfo/owner_info_defect_flag'] !== false) {
      this.$alert('alert', 'オーナー情報を設定してください。');
      this.$router.push({name: 'owner', params: {}});
    }
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode;
    }
    this.listing_data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    // this.pdf_list_get();
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.lodg_id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('list_info_get.php');
    },
    data_get_cb (data) {
      this.lodg_data = data.data.lodg_data;
    },
    listing_data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.listing_data_get_cb;
      ld._load_start('listing_list_get.php');
    },
    listing_data_get_cb (res) {
      this.lists = res.data.listings;

      if (this.mode === 'edit') {
        this.lodg_id = this.$route.params.id;
        this.back = this.$route.params.back;
        this.data_get();
      }
    },
    date_chk (date) {
      let target;
      if (!this.lodg_data.check_in) {
        return true;
      }
      if (typeof this.lodg_data.check_in === 'string') {
        target = this.lodg_data.check_in.replace(/\//g, '');
      } else {
        target = this.$lib._date_text_get(this.lodg_data.check_in);
      }
      const d = this.$lib._date_text_get(date) - 1;
      if (this.$lib._pint(d) < this.$lib._pint(target)) {
        return true;
      }
    },
    new_add () {
      const check_in = this.$children[0].$children[0].formattedValue;
      const check_out = this.$children[1].$children[0].formattedValue;

      // if (this.$lib._emptyChk(this.lodg_data.email) === false) {
      //   this.$alert('alert', '代表者 emailを入力してください。');
      //   return;
      // }
      if (this.$lib._emptyChk(check_in) === false) {
        this.$alert('alert', 'チェックインを入力してください。');
        return;
      }
      if (this.$lib._emptyChk(check_out) === false) {
        this.$alert('alert', 'チェックアウトを入力してください。');
        return;
      }
      // if (this.$lib._emptyChk(this.lodg_data.listing) === false) {
      if (this.$lib._emptyChk(this.lodg_data.listing_id) === false) {
        this.$alert('alert', '部屋番号(部屋名)を選択してください。');
        return;
      }
      this.lodg_data.check_in = check_in;
      this.lodg_data.check_out = check_out;

      if (this.mode === 'add') {
        let ld = new this.$loader(this);
        ld._data_set(this.lodg_data);
        ld._post_cb_f = this.new_add_cb;
        ld._load_start('user_add.php');
      } else {
        let ld = new this.$loader(this);
        ld._data_set({lodg_data: this.lodg_data});
        ld._post_cb_f = this.lodg_edit_cb;
        ld._load_start('list_info_edit.php');
      }
    },
    new_add_cb () {
      this.$router.push({name: 'unregistered', params: {}});
    },
    lodg_edit_cb () {
      this.back_info();
    },
    back_info () {
      this.$router.push({name: 'list_info', params: {lodg_id: this.lodg_id, back: this.back}});
    },
    check_in_select () {
      if (!this.lodg_data.check_out) {
        this.lodg_data.check_out = new Date(this.lodg_data.check_in.getFullYear(), this.lodg_data.check_in.getMonth(), this.lodg_data.check_in.getDate() + 1);
      }
    },
    set_customer_num () {
      if (this.lodg_data.customer_num != 1) {
        this.lodg_data.disp_customer_num = this.lodg_data.customer_num;
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.lodging-add-box {
  text-align: left;

  .main-container {
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      margin: 50px auto 20px auto;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }
    .new-add-s {
      width: 30%;
    }
    .list-box {
      display: flex;
    }
    .list-header-box {
      width: 200px;
      background: #fefefe;

      p {
        background: #fbfbfb;
        color: #24273b;
        border-top: 1px solid #d3d4d8;
        border-left: 1px solid #d3d4d8;
        padding: 10px 15px 10px 0px;

        text-align: right;
        box-sizing: border-box;
        height: 46px;
        &.mail {
          height: 72px;
        }
      }
      p:last-child {
        border-bottom: 1px solid #d3d4d8;
      }
    }
    .list-contents-box {
      flex: 1;

      p {
        background: #fbfbfb;
        border-top: 1px solid #d3d4d8;
        border-left: 1px solid #d3d4d8;
        border-right: 1px solid #d3d4d8;
        padding: 8px;

        box-sizing: border-box;
        height: 46px;
        &.mail {
          height: 72px;
          line-height: 1;
          input {
            margin-bottom: 4px;
          }
          span {
            font-size: 12px;
          }
        }
      }
      p:last-child {
        border-bottom: 1px solid #d3d4d8;
      }
      select,
      input[type="url"]
      input[type="text"] {
        height: 29px;
      }
      input[type="number"] {
        height: 25px;
      }
      .separator {
        margin: 0 8px;
      }
    }
    .num-p {
      width: 60px;
      font-size: 15px;
    }
  }
  @media (max-width: 767px) {
    .main-container {
      .list-header-box {
        width: 120px;
      }
    }
  }
}
</style>
